var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3DEFC",
    stroke: "#6A4FEC",
    strokeWidth: 0.58,
    d: "M13.065 22.04h-.001c.181-1.905 2.134-3.48 4.626-3.48 2.493 0 4.445 1.575 4.627 3.48H13.065z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    fillRule: "evenodd",
    d: "M7.105 12.035c0-.24.195-.435.435-.435h5.076c.24 0 .434.194.434.435 0 .24-.194.435-.434.435H7.54c-.24 0-.435-.195-.435-.435zM7.105 14.064c0-.24.195-.435.435-.435h5.076c.24 0 .434.195.434.435s-.194.435-.434.435H7.54c-.24 0-.435-.195-.435-.435zM7.105 16.095c0-.24.195-.435.435-.435h5.076c.24 0 .434.195.434.435s-.194.435-.434.435H7.54c-.24 0-.435-.195-.435-.435z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A4FEC",
    strokeWidth: 1.4,
    d: "M21.75 22.04H7.25c-.8 0-1.45-.65-1.45-1.45V9.28c0-.8.65-1.45 1.45-1.45h14.5c.801 0 1.45.65 1.45 1.45v11.31c0 .8-.649 1.45-1.45 1.45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A4FEC",
    fillOpacity: 0.34,
    stroke: "#6A4FEC",
    strokeWidth: 1.4,
    d: "M26.335 26.39H2.408c-.254 0-.385-.303-.212-.489L5.37 22.5c.275-.294.658-.46 1.06-.46h16.108c.42 0 .82.182 1.096.5l2.92 3.37c.163.187.03.48-.219.48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A898F4",
    stroke: "#6A4FEC",
    strokeWidth: 0.58,
    d: "M16.948 2.61h-4.605c-.097 0-.174.077-.174.173V5.82c0 .096-.078.174-.174.174H10.8c-.026 0-.039.03-.02.05l3.662 3.692c.068.068.179.068.247 0l3.822-3.854c.019-.018.006-.05-.02-.05h-1.195c-.096 0-.174-.077-.174-.173V2.783c0-.096-.078-.174-.174-.174zM12.478 24.957l-.588 1.433h5.51l-.588-1.433c-.005-.01-.015-.018-.027-.018h-4.28c-.012 0-.022.008-.027.018z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3DEFC",
    stroke: "#6A4FEC",
    strokeWidth: 0.58,
    d: "M20.88 13.92c0 2.125-1.468 3.77-3.19 3.77-1.721 0-3.19-1.645-3.19-3.77 0-2.126 1.469-3.77 3.19-3.77 1.722 0 3.19 1.644 3.19 3.77z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineOnboarding);
export default __webpack_public_path__ + "static/media/online-onboarding.29a1ae6c.svg";
export { ForwardRef as ReactComponent };